import { useEffect, useContext } from 'react';
import { processOutbox } from 'utils/outbox';
import { AuthContext } from 'context';
import { useToast } from 'hooks/useToast';
import { useCookies } from 'react-cookie';
import { OutboxToast } from 'components/OutboxToast';
const OutboxProcessor = () => {
  const { authContext } = useContext(AuthContext);
  const isAuthenticated = authContext?.isAuthenticated;
  const [cookie] = useCookies();
  const { setToastList } = useToast();
  useEffect(() => {
    if (!isAuthenticated) return;

    processOutbox(cookie, setToastList);

    const handleOnline = () => processOutbox(cookie, setToastList);
    window.addEventListener('online', handleOnline);

    const interval = setInterval(() => processOutbox(cookie, setToastList), 3600000);

    return () => {
      window.removeEventListener('online', handleOnline);
      clearInterval(interval);
    };
  }, [isAuthenticated, cookie, setToastList]);

  return <OutboxToast />;
};

export { OutboxProcessor };
